import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import OrastreamImg from "../../images/orastream.png";
import MobileNotAvailableModal from "./mobile-not-available-modal";

const ResponsiveSidebar = ({ open, onClose, history }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const onFastPress = (handler) => (event) => {
    if (event.type === "click" && event.detail > 0) return;
    handler();
  };

  const go = (path) => {
    history.push(path);
    localStorage.removeItem("searchedQuery");
  };

  const handleNavClick = (path) => {
    if (path) {
      go(path);
    }
    onClose();
  };

  const handleNotAvailable = () => {
    onClose();
    setModalVisible(true);
  };

  return (
    <>
    <div className={`responsive-sidebar ${open ? "open" : ""}`}>
      <div className="responsive-sidebar-menu">
        <div className="responsive-sidebar-links">
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(() => handleNavClick("/welcome"))} onClick={onFastPress(() => handleNavClick("/welcome"))}>HOME</button>
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(handleNotAvailable)} onClick={onFastPress(handleNotAvailable)}>FILE CABINET</button>
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(handleNotAvailable)} onClick={onFastPress(handleNotAvailable)}>TIMELINE</button>
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(handleNotAvailable)} onClick={onFastPress(handleNotAvailable)}>PLAYLIST</button>
        </div>

        <div className="responsive-sidebar-divider" />

        <div className="responsive-sidebar-links">
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(() => handleNavClick("/news"))} onClick={onFastPress(() => handleNavClick("/news"))}>NYA TIMES-CONTRARIAN</button>
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(handleNotAvailable)} onClick={onFastPress(handleNotAvailable)}>MOVIE NIGHT</button>
        </div>

        <div className="responsive-sidebar-divider" />

        <div className="responsive-sidebar-links">
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(() => handleNavClick("/about"))} onClick={onFastPress(() => handleNavClick("/about"))}>ABOUT</button>
          <button type="button" className="responsive-sidebar-nav-btn" onPointerUp={onFastPress(() => handleNavClick("/contact"))} onClick={onFastPress(() => handleNavClick("/contact"))}>CONTACT</button>
        </div>

        <div className="responsive-sidebar-divider" />

        <div className="responsive-sidebar-buttons">
          <button type="button" className="responsive-sidebar-btn-primary" onPointerUp={onFastPress(() => handleNavClick("/account?screen=plans"))} onClick={onFastPress(() => handleNavClick("/account?screen=plans"))}>
            SUBSCRIBE
          </button>
          <button
            type="button"
            className="responsive-sidebar-btn-account"
            onPointerUp={onFastPress(() => {
              const path = window.location.pathname;
              localStorage.setItem("path", path);
              const isLoggedIn = !!localStorage.getItem('ade:id-token');
              console.log('[Sidebar:ACCOUNT] tapped, hasAuth =', isLoggedIn);
              handleNavClick(isLoggedIn ? "/account" : "/login");
            })}
            onClick={onFastPress(() => {
              const path = window.location.pathname;
              localStorage.setItem("path", path);
              const isLoggedIn = !!localStorage.getItem('ade:id-token');
              console.log('[Sidebar:ACCOUNT] clicked, hasAuth =', isLoggedIn);
              handleNavClick(isLoggedIn ? "/account" : "/login");
            })}
          >
            ACCOUNT
          </button>
        </div>

        <div className="responsive-sidebar-footer">
          <a
            href="https://www.orastream.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={OrastreamImg} alt="Powered by ORASTREAM" />
          </a>
        </div>
      </div>
    </div>
    <MobileNotAvailableModal
      visible={modalVisible}
      onClose={() => setModalVisible(false)}
    />
    </>
  );
};

export default withRouter(ResponsiveSidebar);
